import { render, staticRenderFns } from "./PORecordPaymentDialog.vue?vue&type=template&id=4cf7fbfc&scoped=true"
import script from "./PORecordPaymentDialog.vue?vue&type=script&lang=ts"
export * from "./PORecordPaymentDialog.vue?vue&type=script&lang=ts"
import style0 from "./PORecordPaymentDialog.vue?vue&type=style&index=0&id=4cf7fbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf7fbfc",
  null
  
)

export default component.exports